<template>
    <div class="topbar-container">
        <div class="scrollbar-container">
            <div class="topimg bg-100"></div>
            <div class="hint r16">
                <zbSwiper
                    ref="swiper"
                    :options="swiperOptions"
                    :data="breakDrivingList"
                    :isCustom="true"
                    designWidth="670"
                    designHeight="447"
                    class="shadow-bg r16 swipe"
                >
                    <van-swipe-item
                        v-for="(item, index) in breakDrivingList"
                        :key="index"
                        class="r16 bv bc"
                    >
                        <div class="carCard r16">
                            <div class="fz_30 headName">中华人民共和国机动车驾驶证</div>
                            <div class="bh bc info fz_28">
                                <div class="leftGrade tc bg-contain bv bc c_white">
                                    <div class="fz_60 scoreNum">{{item.showScore}}</div>
                                    <div class="fz_28">剩余分数</div>
                                </div>
                                <div class="rightInfo bv tl">
                                    <div class="name">姓&emsp;&emsp;名: {{item.registeredName}}</div>
                                    <div class="license">驾驶证号: {{item.number}}</div>
                                    <div class="archives">档案编号: {{item.fileNo}}</div>
                                </div>
                            </div>
                            <div class="bh bc btnWrap">
                                <van-button class="btn btn-goodcart" @click="onDelClick(item.id)">
                                    <div class="fz_28">删除</div>
                                </van-button>
                                <van-button class="btn btn-goodbuy" @click="getDriving(item.id)">
                                    <div class="fz_28">{{item.showText}}</div>
                                </van-button>
                            </div>
                        </div>
                    </van-swipe-item>
                    <van-swipe-item class="r16">
                        <div
                            class="addCard bh bc r16"
                            v-on:click="go('BreakDrivingEdit', {isEdit:false})"
                        >
                            <i class="ico-bg-add bg-contain"></i>
                            <div>
                                <div class="fz_34 title">添加驾照</div>
                                <div class="fz_24 c_999">首次付费后，一周内可免费查询</div>
                            </div>
                        </div>
                    </van-swipe-item>
                </zbSwiper>
            </div>
        </div>
    </div>
</template>

<script>
import { user } from "@/mixin/user";
import { mixinBreak } from "@/mixin/break";
import { delDriving } from "@/api/break";
import util from "@/utils/index";
import zbSwiper from "@/components/swiper/Container";
export default {
    mixins: [user, mixinBreak],
    name: "BreakDrivingHome",
    components: { zbSwiper },
    data() {
        return {
            drivingId: -1,
            swiperOptions: {
                loop: false
            }
        };
    },
    computed: {
        breakDrivingList() {
            return this.$store.state.illegal.drivingList;
        },
        swipeData() {
            return { list: this.breakDrivingList, id: this.drivingId };
        }
    },
    activated() {
        // 页面激活时设置当前主键
        // 避免轮播主键位置不正确
        this.drivingId = this.$store.state.illegal.drivingId;
    },
    watch: {
        // 取消支付返回时选中驾照
        swipeData(data) {
            const { id, list } = data;
            if (id != -1) {
                const index = util.getListIndex(list, id);
                if (index != -1) {
                    this.$refs.swiper.swipeTo(index);
                    // 重置选中驾照id
                    this.drivingId = -1;
                }
            }
        }
    },
    methods: {
        onDelClick(id) {
            this.dialog
                .confirm({
                    title: "提示",
                    message: "确认删除当前驾照信息？"
                })
                .then(() => {
                    delDriving(id).then(res => {
                        this.$store.dispatch("illegal/drivingList", true);
                    });
                });
        },
        // 获取用户数据后执行
        userLoginend() {
            // 获取驾照信息
            this.$store.dispatch("illegal/drivingList");
        }
    }
};
</script>
<style scoped lang="scss">
.scrollbar-container {
    background: #fff;
    .btn-goodbuy {
        margin-left: 10px;
        width: 150px;
        height: 60px;
    }
    .btn-goodcart {
        margin: 0;
        width: 150px;
        height: 60px;
    }
    .topimg {
        padding-top: 40%;
        background-image: url("~@/assets/imges/break/banner.png");
    }
    .hint {
        position: relative;
        margin: -210px 0 0 40px;
        width: 670px;
        .swipe {
            position: initial;
            /deep/.van-swipe__indicators {
                bottom: -30px;

                .van-swipe__indicator {
                    background: #aaa;
                }
            }
        }
        .addCard,
        .carCard {
            background: #fff;
        }
        .addCard {
            height: 100%;
            .ico-bg-add {
                width: 180px;
                height: 180px;
                margin-right: 34px;
            }
            .title {
                padding-bottom: 20px;
            }
        }

        .carCard {
            .headName {
                padding: 20px 0;
            }
            .license {
                padding: 10px 0;
            }
            width: calc(100% - 80px);
            padding: 0 40px;
            .info {
                border-top: 1px solid #efeeee;
                border-bottom: 1px solid #efeeee;
                padding: 30px 0 40px 0;
                .scoreNum {
                    line-height: 1;
                }
                .leftGrade {
                    width: 140px;
                    height: 140px;
                    margin-right: 20px;
                    background-image: url("~@/assets/imges/break/grade.png");
                }
            }
            .btnWrap {
                padding: 30px 0 40px 0;
            }
        }
    }
}
[data-theme="app"] {
    .scrollbar-container {
        .topimg {
            background-image: url("~@/assets/imges/app/break/banner.png");
        }
        .hint {
            .carCard {
                .info {
                    .leftGrade {
                        background-image: url("~@/assets/imges/app/break/grade.png");
                    }
                }
            }
        }
    }
}
</style>
